export default function ({state, getters}) {
    if(state.system.action!=='edit'){
        state.form.Sum = getters['agreements/sum_all'];
    }
}